$(document).ready(function () {
	let tmSearch;
	let hSearchContent = $('.search-form').find('.search-content');
	let body = $("body");
	let headerWrapper = $(".header .header-wrapper");
	let documentWidth = parseInt(document.documentElement.clientWidth);
	let windowsWidth = parseInt(window.innerWidth);
	let scrollbarWidth = windowsWidth - documentWidth;

	$('.search-input').on('keyup', function () {
		$('.search-input').not(this).val($(this).val());

		let $self = $(this);
		let search = $self.val();

		clearTimeout(tmSearch);

		if (search) {
			tmSearch = setTimeout(() => {
				hSearchContent.addClass('focused');

				$.get('/search/lookup', {search: search}, function (data) {
					let content;

					if(window.innerWidth < 768) {
						content = $('.vg-mobile-panel')
					} else {
						content = $('.header-bottom')
					}

					if (data.view) {
						content.find('.search-area').find('.vg-search-content-body').html(data.view);
						hSearchContent.addClass('focused');

						if(window.innerWidth < 991) {
							bodyPaddingVisible();

							console.log(hSearchContent);
							hSearchContent[1].scrollTo({
								behavior: "smooth",
								top: hSearchContent[0].offsetTop
							})
						}

					} else {
						hSearchContent.removeClass('focused');

						if(window.innerWidth < 991) {
							bodyPaddingHidden();
						}
					}
				});
			}, 500);
		} else {
			hSearchContent.removeClass('focused');
		}
	});

	const bodyPaddingVisible = () => {
		body.css("padding-right", `${scrollbarWidth}px`);
		body.css("overflow","hidden");
	};

	const bodyPaddingHidden = () => {
		body.css("padding-right", `0px`);
		body.css("overflow","auto");
	};

	const hiddenSearch = () => {
		hSearchContent.removeClass('focused');
	};

	const headerPaddingVisible = () => {
		headerWrapper.css("padding-right", `${scrollbarWidth}px`);
	};

	const headerPaddingHidden = () => {
		headerWrapper.css("padding-right", `0px`);
	};

	document.onclick = (e) => {
		if (!e.target.closest('.search-content')) {
			hiddenSearch();
			bodyPaddingHidden();
			headerPaddingHidden();
		}
	};

	window.onscroll = () => {
		actionWithSearch(() => {
			if(headerWrapper.hasClass('fixed')) {
				headerPaddingVisible();
			} else {
				headerPaddingHidden();
			}
		}, () => {
			if(headerWrapper.hasClass('fixed')) {
				headerPaddingHidden();
			}
		});
	};

	const actionWithSearch = (visible, hidden) => {
		hSearchContent.on('mouseleave', function (e) {
			if(e.target.closest('.search-content')) {
				bodyPaddingHidden();

				if(typeof hidden === 'function') {
					hidden();
				}
			}
		});

		hSearchContent.on('scroll', function (event) {
			bodyPaddingVisible();

			if(typeof visible === 'function') {
				visible();
			}
		});
	};

	$('[data-toggle=search]').click(function () {
		let $search = $('.vg-search');

		$search.toggleClass('show');

		if($search.hasClass('show')) {
			$(this).find('i').removeClass().addClass('fa-regular fa-square-xmark');
		} else {
			bodyPaddingHidden();
			$(this).find('i').removeClass().addClass('fa fa-search');
		}

		if ($search.hasClass('show')) {
			setTimeout(() => {
				$search.find('input').focus();
			}, 500)
		}

		return false;
	});

	actionWithSearch();
});